import React, { useContext } from "react";
import { LoginPageContext } from "../LoginPageView";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Form from "react-bootstrap/Form";
import InputComponent from "../../../components/InputComponent/InputComponent";
import { BorderButton } from "../../../components/BorderButton/BorderButton";
import { FillButton } from "../../../components/FillButton/FillButton";
import Loader from "../../../components/LoaderComponent/LoaderComponent";
import { PopupComponent } from "../../../components/PopupComponent/PopupComponent";
import ErrorIcon from "../../../assets/images/icons/error-icon.svg";
import SuccessIcon from "../../../assets/images/icons/popup-success-icon.svg";
import Logo from "../../../assets/images/VG-logo.svg";
import "./loginPage.css";

export const LoginPage = () => {
  const {
    pageStaticContent,
    onHandleEmailWithOTP,
    onHandleEmailWithPassword,
    checkEmailWithOTP,
    checkEmailPassword,
    setKey, // active tab
    showLoader, // Loader status
    showErrorPopup, // error popup state
    errorPopupMessage, //erro popup message state
    showSuccessPopup, //success popup state
    successPopupMsg, //success popup message state

    onClickPopuptryAgain, // on click error popup try again button
    onClickContinueButton, // on click success popup continue button

    // Email
    onChangeEmailId, // email onchange
    emailId, // email state
    emailValidationMsg, // email validation message state

    // Phone number
    onChangePhoneNumber, // phone number onChange
    phoneNumber, // phone number state
    numberValidationMsg, // phone number validation state

    // otp
    onChangeOTP, // otp onChange
    otpValue, //otp state

    onHandleGetOTP, // function to get otp
    onHandleLogin, // onclick login

    onChangePassword, //email with password | onchange password input
    password, // email with password |  password contain state
    passwordValdiation, // email with password |  password validation message
    buttonEnableStatus,

    otpKeyDown, // onkeyDown otp
    onKeyDownNumber, // onKeyDown phone number
    enableOtpField, // enable otp field after getting otp
    buttonText, // get otp button text
    getOtpButtonDisable, // get otp button disable state

    loginTypeAmazon, // login for amazon
  } = useContext(LoginPageContext);


  return (
    <div className="login-page">
      {showLoader && <Loader />}
      <div className="mobile-device-container login-container">
        {loginTypeAmazon ? (
          <>
            <div className="text-center">
              <img src={Logo} alt="logo" className="vg-logo" />
            </div>
            <p className="welcome-text text-center">
              {pageStaticContent.welcomeText}
            </p>
            <div className="signin-text">{pageStaticContent.loginText}</div>
          </>
        ) : (
          <>
            <div className="text-center">
              <img src={Logo} alt="logo" className="vg-logo" />
            </div>
            <p className="welcome-description">
              {pageStaticContent.description}
            </p>
            <div className="signin-text">{pageStaticContent.loginText}</div>
          </>
        )}

        <section>
          <Tabs
            defaultActiveKey="email"
            id="uncontrolled-tab-example"
            className="mb-3"
            onSelect={(e) => setKey(e)}
          >
            <Tab eventKey="email" title="Email">
              <Form className="mt-4">
                <div key="inline-radio" className="mb-3 radio-button-container">
                  <Form.Check
                    className={checkEmailWithOTP ? "radio-label" : ""}
                    type="radio"
                    label="Email with OTP"
                    name="group1"
                    id="emailOTP"
                    onClick={onHandleEmailWithOTP}
                    checked={checkEmailWithOTP}
                  />
                  <Form.Check
                    className={
                      checkEmailPassword
                        ? "radio-label password-margin-left"
                        : "password-margin-left"
                    }
                    type="radio"
                    label="Email with Password"
                    name="group1"
                    id="emailPassword"
                    onClick={onHandleEmailWithPassword}
                    checked={checkEmailPassword}
                  />
                </div>
              </Form>
              <Form
                className={checkEmailWithOTP === false ? "hide-fields" : ""}
              >
                <InputComponent
                  placeholder="Email Id"
                  type="text"
                  customClass="input-top-margin"
                  onChange={onChangeEmailId}
                  message={emailValidationMsg}
                  value={emailId}
                />
                <BorderButton
                  text={buttonText}
                  buttonClass="otp-button"
                  onClick={onHandleGetOTP}
                  disabled={getOtpButtonDisable}
                />

                <InputComponent
                  placeholder="Enter 4 digit OTP"
                  type="text"
                  inputMode="numeric"
                  maxLength={4}
                  onPaste={(e) => {
                    const otp = e.clipboardData.getData("text").trim();
                    if (/^\d{4}$/.test(otp)) {
                      e.preventDefault();
                      onChangeOTP({ target: { value: otp } });
                    }
                  }}
                  customClass="otp-input"
                  onChange={onChangeOTP}
                  value={otpValue}
                  onKeyDown={otpKeyDown}
                  disabled={enableOtpField}
                />
              </Form>
              <Form
                className={checkEmailPassword === false ? "hide-fields" : ""}
              >
                <InputComponent
                  placeholder="Email Id"
                  type="text"
                  customClass="input-top-margin"
                  onChange={onChangeEmailId}
                  value={emailId}
                  message={emailValidationMsg}
                />

                <InputComponent
                  placeholder="Password"
                  type="password"
                  customClass="password-input"
                  onChange={onChangePassword}
                  value={password}
                  message={passwordValdiation}
                />
                <FillButton
                  text="Login"
                  fillButtonClass="login-button"
                  disabled={buttonEnableStatus ? false : true}
                  onClick={onHandleLogin}
                />
              </Form>
            </Tab>
            <Tab eventKey="phone" title="Phone">
              <Form className="mt-4">
                <div key="inline-radio" className="mb-3 radio-button-container">
                  <Form.Check
                    className={checkEmailWithOTP ? "radio-label" : ""}
                    type="radio"
                    label="Phone number with OTP"
                    name="group2"
                    id="inline-radio-1"
                    checked={true}
                  />
                </div>
              </Form>
              <Form>
                <InputComponent
                  placeholder="Phone Number"
                  type="number"
                  customClass="input-top-margin"
                  value={phoneNumber}
                  onChange={onChangePhoneNumber}
                  message={numberValidationMsg}
                  onKeyDown={onKeyDownNumber}
                />
                <BorderButton
                  text={buttonText}
                  buttonClass="otp-button"
                  onClick={onHandleGetOTP}
                  disabled={getOtpButtonDisable}
                />

                <InputComponent
                  placeholder="Enter 4 digit OTP"
                  type="text"
                  inputMode="numeric"
                  maxLength={4}
                  onPaste={(e) => {
                    const otp = e.clipboardData.getData("text").trim();
                    if (/^\d{4}$/.test(otp)) {
                      e.preventDefault();
                      onChangeOTP({ target: { value: otp } });
                    }
                  }}
                  customClass="otp-input"
                  onChange={onChangeOTP}
                  value={otpValue}
                  onKeyDown={otpKeyDown}
                  disabled={enableOtpField}
                />
              </Form>
            </Tab>
          </Tabs>
        </section>
      </div>

      {/* Error popup */}
      <PopupComponent
        title="Error"
        show={showErrorPopup}
        message={errorPopupMessage}
        fillButtonText="Try again"
        fillButtonClick={onClickPopuptryAgain}
        icon={ErrorIcon}
      />

      {/* Success popup */}
      <PopupComponent
        title="Success"
        show={showSuccessPopup}
        message={successPopupMsg}
        fillButtonText="Continue"
        fillButtonClick={onClickContinueButton}
        icon={SuccessIcon}
      />
    </div>
  );
};
